// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"a514c3c8","197":"6676acc9","402":"8d18e8ed","725":"ec505879","759":"6b0d3e57","897":"67797c3e"}[chunkId] + ".chunk.js";
};